export const filterStatus = [
    {name: '--- Tất cả ---', value: ''},
    {name: 'Bật', value: true},
    {name: 'Tắt', value: false},
]

export const limitSetting = [
    {name: '20 rows', value: 20},
    {name: '30 rows', value: 30},
    {name: '40 rows', value: 40},
    {name: '50 rows', value: 50},
    {name: '100 rows', value: 100},
    {name: '200 rows', value: 200},
    {name: '500 rows', value: 500},
]

export const filterProcedure = [
    {name: '--- Tất cả ---', value: ''},
    {name: '2D', value: '2D'},
    {name: '3D', value: '3D'},
]

export const filterMex = [
    {name: '--- Tất cả ---', value: ''},
    {name: 'Có ép mex', value: true},
    {name: 'Không ép mex', value: false},
]

export const filterCutLaze = [
    {name: '--- Tất cả ---', value: ''},
    {name: 'Có cắt laze', value: true},
    {name: 'Không cắt laze', value: false},
]